// timerUtils.js（简化版）
const timerUtils = {
  setInterval(component, fn, interval) {
    // 为组件创建一个timer标识
    if (!component._timers) {
      component._timers = [];
    }
    
    const timer = setInterval(() => {
      // 添加页面可见性检查
      if (!document.hidden) {
        fn();
      }
    }, interval);
    
    component._timers.push(timer);
    return timer;
  },
  
  clearTimers(component) {
    if (component._timers) {
      component._timers.forEach(timer => clearInterval(timer));
      component._timers = [];
    }
  }
};